import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import GenericButton from '../../../../components/GenericButton'
import { type HandleBackFn, type HandleNextFn } from '../SurveyFeatureStepper/types'
import { useStepper } from '../SurveyFeatureStepper/useStepper'
import { ButtonSize, ButtonType } from '../../../../components/GenericButton/styles'
import ProgressBar from '../ProgressBar'
import { getIsSubmitting } from '../../../../store/slices/studentSurveyListSlice/selectors'

interface RenderControlsProps {
  handleBack: HandleBackFn
  handleNext: HandleNextFn
  sections: any
}

export const StepNavigation: React.FC<RenderControlsProps> = (props: RenderControlsProps) => {
  const { handleBack, handleNext, sections } = props
  // CR-260: `loading` is this button's double-submit guard — `GenericButton` drops `onClick`
  // while it is set. Submits track `isSubmitting`, not `isLoading`; the survey now stays
  // mounted for the whole request, so the button must disable itself rather than relying on
  // the page swapping it out.
  const isSubmitting = getIsSubmitting()

  const theme = useTheme()

  const { step } = useStepper()

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        p={`${theme.spacing(2, 4)}`}
        mt={theme.spacing(6)}
        position={'fixed'}
        width={'100%'}
        bottom={0}
        right={0}
        bgcolor={'white'}
        style={{ boxShadow: '0px -4px 4px -3px rgba(0,0,0,0.3)' }}
      >
        <Box display={{ xs: 'none', md: 'flex' }} width={'100%'} justifyContent={'space-between'} alignItems={'center'}>
          <GenericButton buttonSize={ButtonSize.Small} label='Back' buttonType={ButtonType.Primary} onClick={handleBack} disabled={step === 0} />
          <ProgressBar />
          <Box display={'flex'} gap={3} alignItems={'center'}>
            <Typography fontSize='18px'><b>{step + 1} of {sections.length}</b> sections </Typography>
            <GenericButton buttonSize={ButtonSize.Small} label={sections.length - 1 === step ? 'Submit' : 'Next'} buttonType={ButtonType.Primary} onClick={handleNext} loading={isSubmitting} />
          </Box>
        </Box>

        <Box display={{ xs: 'flex', md: 'none' }} width={'100%'} flexDirection={'column'} alignItems={'center'} gap={1}>
          <Box width={'100%'}>
            <ProgressBar />
          </Box>
          <Box display={'flex'} width={'100%'} alignItems={'center'}>
            <Box>
              <GenericButton buttonSize={ButtonSize.Small} label='Back' buttonType={ButtonType.Primary} onClick={handleBack} disabled={step === 0} />
            </Box>
            <Box flex={1} display={'flex'} justifyContent={'center'}>
              <Typography fontSize='16px'><b>{step + 1} of {sections.length}</b> sections</Typography>
            </Box>
            <Box>
              <GenericButton buttonSize={ButtonSize.Small} label={sections.length - 1 === step ? 'Submit' : 'Next'} buttonType={ButtonType.Primary} onClick={handleNext} loading={isSubmitting} />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
